export default {"src":"/_next/static/media/partners.8639b2d4.svg","height":711,"width":1920,"blurWidth":0,"blurHeight":0};